import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchExpenses,
  createExpense,
  updateExpense,
  deleteExpense,
  patchExpense,
} from "./thunks";
import { Expense } from "@/types";
import { toast } from "react-toastify";

interface PaginatedExpenses {
  data: Expense[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface ExpensesState {
  expenses: PaginatedExpenses;
  loading: boolean;
  error: string | null;
}

const initialState: ExpensesState = {
  expenses: { data: [] },
  loading: false,
  error: null,
};

const ExpenseSlice = createSlice({
  name: "expenses",
  initialState,
  reducers: {
    clearSuppliers: (state) => {
      state.expenses = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExpenses.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload = action.payload;

        if (Array.isArray(payload.data)) {
          // Dados não paginados
          state.expenses = { data: payload.data };
        } else {
          // Dados paginados
          state.expenses = {
            data: payload.data.data,
            total: payload.data.total,
            currentPage: payload.data.current_page,
            perPage: payload.data.per_page,
          };
        }
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createExpense.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.expenses.data.push(action.payload.data);
        toast.success("Despesa cadastrada com sucesso!");
      })
      .addCase(createExpense.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error(
          "Não foi possível cadastrar essa despesa, tente novamente!",
        );
      })

      // Update
      .addCase(updateExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateExpense.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.expenses.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.expenses.data[index] = action.payload.data;
        }
        toast.success("Despesa atualizada com sucesso!");
      })
      .addCase(updateExpense.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // Delete
      .addCase(deleteExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteExpense.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.expenses.data = state.expenses.data.filter(
          (s) => String(s.id) != action.payload.data.id,
        );
        toast.success("Despesa excluída com sucesso!");
      })
      .addCase(deleteExpense.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })

      // Patch
      .addCase(patchExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(patchExpense.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.expenses.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.expenses.data[index] = action.payload.data;
        }
        toast.success("Baixa de despesa realizada com sucesso!");
      })
      .addCase(patchExpense.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      });
  },
});

export default ExpenseSlice.reducer;
